export const creatorCategories = [
  {
    key: "美食",
    name: "美食",
    icon: "ri-restaurant-2-line",
    desc: "烹饪教程、探店与地方风味，从后厨到街头一网打尽。",
    highlight: "复刻性与烟火气兼具",
  },
  {
    key: "三农",
    name: "三农",
    icon: "ri-plant-line",
    desc: "乡村生活、种植养殖与农事记录，真实感是最大魅力。",
    highlight: "质朴、耐看、有信息量",
  },
  {
    key: "知识科普",
    name: "知识科普",
    icon: "ri-lightbulb-line",
    desc: "自然科学、器物文化与数码知识，用通俗语言讲清门道。",
    highlight: "轻松涨知识的首选",
  },
  {
    key: "生活记录",
    name: "生活记录",
    icon: "ri-roadster-line",
    desc: "跨文化观察、旅行与户外日常，重在视角与体验。",
    highlight: "代入感强、开阔眼界",
  },
  {
    key: "传统文化",
    name: "传统文化",
    icon: "ri-ancient-gate-line",
    desc: "手作、节气与东方生活方式，画面讲究、节奏舒缓。",
    highlight: "美学与慢节奏并存",
  },
  {
    key: "汽车",
    name: "汽车",
    icon: "ri-car-line",
    desc: "车型评测与用车科普，帮你在选车时少走弯路。",
    highlight: "实用导向、通俗易懂",
  },
  {
    key: "户外",
    name: "户外",
    icon: "ri-fire-line",
    desc: "露营、野外技能与徒步见闻，把玩法讲成可上手的方法。",
    highlight: "技能扎实、可操作",
  },
  {
    key: "亲子",
    name: "亲子",
    icon: "ri-parent-line",
    desc: "亲子互动与成长记录，氛围温暖、贴近日常。",
    highlight: "治愈系、共鸣度高",
  },
];

export const ecosystemStats = [
  {
    value: "8 大",
    label: "常青内容领域",
    note: "覆盖美食、三农、科普、生活等高频赛道",
    icon: "ri-grid-line",
  },
  {
    value: "3 类",
    label: "创作者梯队",
    note: "头部大V、优质达人、潜力新人各有看点",
    icon: "ri-stack-line",
  },
  {
    value: "长视频",
    label: "平台内容底色",
    note: "以中长视频见长，适合深度叙事与知识输出",
    icon: "ri-movie-2-line",
  },
  {
    value: "持续",
    label: "生态更新节奏",
    note: "新人不断涌现，榜单与风格长期在变化",
    icon: "ri-refresh-line",
  },
];

export const rankingList = [
  {
    rank: 1,
    name: "李子柒",
    category: "传统文化",
    reason: "把田园生活与传统手艺拍成国际传播样本，长期领跑文化类内容。",
    tags: ["文化出海", "慢内容", "高辨识度"],
    medal: "ri-vip-crown-line",
  },
  {
    rank: 2,
    name: "华农兄弟",
    category: "三农",
    reason: "以幽默化解农活的枯燥，是三农题材走向大众的关键账号之一。",
    tags: ["乡村真实感", "轻松幽默", "入门友好"],
    medal: "ri-medal-line",
  },
  {
    rank: 3,
    name: "美食作家王刚",
    category: "美食",
    reason: "职业厨师视角的硬核教学，复现率高，被当作可落地的厨房教材。",
    tags: ["技术流", "可复现", "川菜代表"],
    medal: "ri-medal-line",
  },
  {
    rank: 4,
    name: "无穷小亮",
    category: "知识科普",
    reason: "把辟谣与博物知识讲成大众话题，科普类互动与传播表现突出。",
    tags: ["趣味科普", "高频互动", "知识密度"],
    medal: "ri-award-line",
  },
  {
    rank: 5,
    name: "老饭骨",
    category: "美食",
    reason: "资深大厨组合输出饮食文化，兼顾手艺传承与家庭可操作性。",
    tags: ["饮食文化", "家常讲究", "口碑稳"],
    medal: "ri-award-line",
  },
  {
    rank: 6,
    name: "我是郭杰瑞",
    category: "生活记录",
    reason: "跨文化对比视角鲜明，长期稳定产出讨论度较高的生活观察内容。",
    tags: ["跨文化", "观察视角", "话题性"],
    medal: "ri-award-line",
  },
  {
    rank: 7,
    name: "大能",
    category: "知识科普",
    reason: "把冷门钟表机械讲出温度，器物类科普中辨识度与忠诚度双高。",
    tags: ["器物美学", "垂直深耕", "高粘性"],
    medal: "ri-bookmark-3-line",
  },
  {
    rank: 8,
    name: "燃茶哥哥",
    category: "生活记录",
    reason: "摩旅与户外题材画面出色，代表了生活记录赛道的自由表达方向。",
    tags: ["摩旅", "户外", "画面感"],
    medal: "ri-bookmark-3-line",
  },
];

export const faqList = [
  {
    q: "西瓜视频上的“网红”主要指哪些人？",
    a: "通常指在平台持续发布中长视频、并积累了一定关注度与影响力的内容创作者，包括头部大V、优质达人与上升期的新人。他们多以内容领域被记住，比如美食、三农、知识科普、生活记录等，而不是单纯靠某个热点走红。",
  },
  {
    q: "为什么有的创作者同时活跃在多个平台？",
    a: "很多创作者会选择多平台分发，把同一内容投放到不同社区。因此你在西瓜视频看到的账号，可能也在其他平台更新。判断一个创作者是否适合自己，关键还是看他最擅长的内容领域与长期稳定的更新节奏。",
  },
  {
    q: "榜单是怎样排序的，能当权威排名吗？",
    a: "本页的榜单是依据内容领域影响力、内容辨识度与稳定产出整理的编辑视角速览，属于参考性梳理，并非平台官方排名。平台的账号数据、推荐机制都在持续变化，建议把它当作“从哪里开始看”的索引，而不是绝对名次。",
  },
  {
    q: "只关注头部创作者的粉丝量有意义吗？",
    a: "粉丝量只反映规模，不等于内容就适合你。头部账号胜在稳定与完成度高，但细分领域的优质达人、潜力新人往往更贴近具体需求。建议先按内容领域筛选，再从你真正会看完的作品里判断要不要长期关注。",
  },
  {
    q: "怎样快速判断一个创作者值不值得追？",
    a: "可以先看三件事：一是最近三个月是否稳定更新；二是单条作品的评论与互动是否围绕内容本身；三是他有没有持续深耕一个领域。满足这几点的账号，通常更值得长期关注，也更不容易“断更”。",
  },
  {
    q: "新兴领域的创作者会不会很快过气？",
    a: "任何领域都会经历热度起伏，但专注垂直内容的创作者抗风险能力更强。与其追逐短期热点，不如关注那些把方法、经验或审美沉淀下来的账号，这类内容即使热度过去了，依然有回看价值。",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "先锁定内容领域",
    desc: "从美食、三农、科普等方向里挑一到两个你真正会看的，范围越聚焦，越容易找到合口味的创作者。",
    icon: "ri-focus-3-line",
  },
  {
    step: "02",
    title: "再看更新节奏",
    desc: "打开主页确认最近三个月是否稳定更新。长期稳定产出，通常意味着内容质量与创作状态都在线。",
    icon: "ri-calendar-check-line",
  },
  {
    step: "03",
    title: "试看三条代表作",
    desc: "不必从最新一条开始，先找评论与讨论最集中的代表作，能更快判断他的风格是不是你的菜。",
    icon: "ri-play-circle-line",
  },
  {
    step: "04",
    title: "观察评论区氛围",
    desc: "评论区是在聊内容本身，还是在吵无关话题，往往能反映账号的整体调性，也能帮你预判长期体验。",
    icon: "ri-chat-smile-2-line",
  },
  {
    step: "05",
    title: "给新人一点耐心",
    desc: "潜力新人更新快、互动也积极，早一点关注往往能陪着一个账号一起成长，性价比很高。",
    icon: "ri-seedling-line",
  },
];

export const guideChecklist = [
  "最近 3 个月是否持续更新",
  "是否长期深耕同一内容领域",
  "单条作品的互动是否围绕内容",
  "画面与讲述是否形成了个人风格",
  "是否有值得回看的系列或合集",
  "评论区氛围是否友好、有讨论度",
];